import React, { ChangeEvent, FormEvent, useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import styles from './styles.module.css'
import { LoginAuthDto } from '../../services/generated/client'

const Login = () => {
  const { login } = useAuth()

  const [credentials, setCredentials] = useState<LoginAuthDto>({
    username: '',
    password: ''
  })

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setCredentials((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    await login(credentials.username, credentials.password)
  }

  return (
    <div className={styles.container}>
      <div className={styles.loginCard}>
        <h2>Login</h2>
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.content}>
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.content}>
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit">Log In</button>
        </form>
      </div>
      <span className={styles.footerText}>
        Crafted by{' '}
        <a
          title="Crafted by Artisans"
          href="https://artisans.ge/ka"
          target="_blank"
          rel="noopener"
        >
          ARTISANS
        </a>
      </span>
    </div>
  )
}

export default Login
